import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Newspaper, Calendar, User } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Nieuws() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/news`).then(r => setPosts(r.data)).catch(() => {});
  }, []);

  const formatDate = (d) => d ? new Date(d).toLocaleDateString('nl-BE', { day: 'numeric', month: 'long', year: 'numeric' }) : '';

  return (
    <div data-testid="nieuws-page">
      <section className="relative pt-40 pb-24 overflow-hidden" style={{ background: 'linear-gradient(135deg, #16224b 0%, #233a80 58%, #f2a100 100%)' }}>
        <div className="dot-pattern absolute inset-0" />
        <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 text-center">
          <h1 className="text-white font-bold tracking-tight mb-4" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', letterSpacing: '-0.03em' }}>
            IT-inzichten & nieuws
          </h1>
          <p className="text-white/70 max-w-xl mx-auto text-base leading-8">
            Blijf op de hoogte van de laatste trends, tips en nieuws uit de IT-wereld.
          </p>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          {posts.length === 0 ? (
            <div className="text-center py-20">
              <Newspaper className="w-16 h-16 text-gray-200 mx-auto mb-6" />
              <p className="text-[#6b7184]">Nog geen publicaties beschikbaar.</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map((post, i) => (
                <Link key={post.id || i} to={`/nieuws/${post.id}`} className="group bg-white rounded-lg border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                  {post.afbeelding && (
                    <div className="overflow-hidden" style={{ height: 200 }}>
                      <img src={post.afbeelding} alt={post.titel} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    </div>
                  )}
                  <div className="p-6">
                    <div className="flex items-center gap-4 text-xs text-[#6b7184] mb-4">
                      <span className="flex items-center gap-1"><Calendar className="w-3 h-3" />{formatDate(post.created_at || post.datum)}</span>
                    </div>
                    <h3 className="text-[#16224b] font-bold text-lg mb-3 line-clamp-2 group-hover:text-[#3d56a6] transition-colors">{post.titel}</h3>
                    <p className="text-[#6b7184] text-sm leading-7 line-clamp-3">{post.samenvatting || post.inhoud?.substring(0, 120)}</p>
                    <span className="inline-flex items-center gap-1 text-[#3d56a6] text-sm font-semibold mt-4">
                      Lees meer <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
